import { httpPost, httpGet } from "./request";
/** 获取目录树 */
export const treeData = (data: any) => {
  return httpGet({
    url: "/ikg/dict/directory/query",
    data,
  });
};

/** 获取标准版本 */
export const standardVersion = (data: any) => {
  return httpGet({
    url: "/ikg/dict/version/query",
    data,
  });
};

export const getItem = (data: any) => {
  return httpGet({
    url: "/ikg/dict/item/query",
    data,
  });
};
